import type { ReactNode } from "react";

export function PageHero({
  eyebrow, title, sub, children,
}: { eyebrow?: string; title: ReactNode; sub?: string; children?: ReactNode }) {
  return (
    <section className="relative overflow-hidden pt-32 pb-16 sm:pt-40 sm:pb-20">
      {/* grid + teal top glow come from the global backdrop (App.tsx) */}
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6">
        {eyebrow && (
          <div className="text-xs font-medium uppercase tracking-[0.22em] text-primary">{eyebrow}</div>
        )}
        <h1 className="mt-3 font-display text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl md:text-6xl">
          {title}
        </h1>
        {sub && (
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg">{sub}</p>
        )}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </section>
  );
}
